import React, { useEffect, useState } from 'react';
const HOTMART = 'https://pay.hotmart.com/O103704589E';
export function FloatingCTA() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed bottom-0 left-0 right-0 z-50 md:hidden p-3 bg-white/95 backdrop-blur-sm border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.1)] transition-transform duration-300 ease-out ${show ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-162">
      <a href={HOTMART} target="_blank" rel="noopener noreferrer" className="block w-full py-3.5 rounded-full text-white font-bold text-lg text-center tracking-widest uppercase shadow-lg transition-all" style={{
      fontFamily: "'Cormorant Garamond', serif",
      letterSpacing: '0.1em',
      background: 'linear-gradient(135deg, #1a6b3a 0%, #2d9a55 50%, #1a6b3a 100%)',
      boxShadow: '0 4px 20px rgba(29,107,58,0.4)'
    }} data-id="element-163">
        🔥 ACCEDE AL CURSO HOY ⚡
      </a>
    </div>;
}